// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173'),
	() => import('./nodes/174'),
	() => import('./nodes/175'),
	() => import('./nodes/176'),
	() => import('./nodes/177'),
	() => import('./nodes/178'),
	() => import('./nodes/179'),
	() => import('./nodes/180'),
	() => import('./nodes/181'),
	() => import('./nodes/182'),
	() => import('./nodes/183'),
	() => import('./nodes/184'),
	() => import('./nodes/185'),
	() => import('./nodes/186'),
	() => import('./nodes/187'),
	() => import('./nodes/188'),
	() => import('./nodes/189'),
	() => import('./nodes/190'),
	() => import('./nodes/191'),
	() => import('./nodes/192'),
	() => import('./nodes/193'),
	() => import('./nodes/194'),
	() => import('./nodes/195'),
	() => import('./nodes/196'),
	() => import('./nodes/197'),
	() => import('./nodes/198'),
	() => import('./nodes/199'),
	() => import('./nodes/200'),
	() => import('./nodes/201'),
	() => import('./nodes/202'),
	() => import('./nodes/203'),
	() => import('./nodes/204'),
	() => import('./nodes/205'),
	() => import('./nodes/206'),
	() => import('./nodes/207'),
	() => import('./nodes/208'),
	() => import('./nodes/209'),
	() => import('./nodes/210'),
	() => import('./nodes/211'),
	() => import('./nodes/212'),
	() => import('./nodes/213'),
	() => import('./nodes/214'),
	() => import('./nodes/215'),
	() => import('./nodes/216'),
	() => import('./nodes/217'),
	() => import('./nodes/218'),
	() => import('./nodes/219'),
	() => import('./nodes/220'),
	() => import('./nodes/221'),
	() => import('./nodes/222'),
	() => import('./nodes/223'),
	() => import('./nodes/224'),
	() => import('./nodes/225'),
	() => import('./nodes/226'),
	() => import('./nodes/227'),
	() => import('./nodes/228'),
	() => import('./nodes/229'),
	() => import('./nodes/230'),
	() => import('./nodes/231'),
	() => import('./nodes/232'),
	() => import('./nodes/233'),
	() => import('./nodes/234'),
	() => import('./nodes/235'),
	() => import('./nodes/236'),
	() => import('./nodes/237'),
	() => import('./nodes/238'),
	() => import('./nodes/239'),
	() => import('./nodes/240'),
	() => import('./nodes/241'),
	() => import('./nodes/242'),
	() => import('./nodes/243'),
	() => import('./nodes/244'),
	() => import('./nodes/245'),
	() => import('./nodes/246'),
	() => import('./nodes/247'),
	() => import('./nodes/248'),
	() => import('./nodes/249'),
	() => import('./nodes/250'),
	() => import('./nodes/251'),
	() => import('./nodes/252'),
	() => import('./nodes/253'),
	() => import('./nodes/254'),
	() => import('./nodes/255'),
	() => import('./nodes/256'),
	() => import('./nodes/257'),
	() => import('./nodes/258'),
	() => import('./nodes/259'),
	() => import('./nodes/260'),
	() => import('./nodes/261'),
	() => import('./nodes/262'),
	() => import('./nodes/263'),
	() => import('./nodes/264'),
	() => import('./nodes/265'),
	() => import('./nodes/266'),
	() => import('./nodes/267'),
	() => import('./nodes/268'),
	() => import('./nodes/269'),
	() => import('./nodes/270'),
	() => import('./nodes/271'),
	() => import('./nodes/272'),
	() => import('./nodes/273'),
	() => import('./nodes/274'),
	() => import('./nodes/275'),
	() => import('./nodes/276'),
	() => import('./nodes/277'),
	() => import('./nodes/278'),
	() => import('./nodes/279'),
	() => import('./nodes/280'),
	() => import('./nodes/281'),
	() => import('./nodes/282'),
	() => import('./nodes/283'),
	() => import('./nodes/284'),
	() => import('./nodes/285'),
	() => import('./nodes/286'),
	() => import('./nodes/287'),
	() => import('./nodes/288'),
	() => import('./nodes/289'),
	() => import('./nodes/290'),
	() => import('./nodes/291'),
	() => import('./nodes/292')
];

export const server_loads = [0,30,5,23,27,28,29,9,3,16,4];

export const dictionary = {
		"/(marketing)": [~216,[30]],
		"/(marketing)/academics": [235,[30]],
		"/(auth)/(signin)/account-migration/verify/[token]": [37,[2]],
		"/(auth)/(signin)/account-pending": [38,[2]],
		"/(marketing)/(redirects)/(utm)/andreas": [217,[31]],
		"/(dash)/apps/[workspace]/[environment]": [53,[5],[6]],
		"/(dash)/apps/[workspace]/[environment]/deployed/[name]": [55,[5],[6]],
		"/(dash)/apps/[workspace]/[environment]/v2": [56,[5],[6]],
		"/(dash)/apps/[workspace]/[environment]/[appId]": [54,[5],[6]],
		"/(marketing)/articles": [236,[30]],
		"/(auth)/(signin)/authorize": [39,[2]],
		"/(marketing)/(redirects)/(utm)/bigboxswe": [218,[31]],
		"/(marketing)/blog": [~237,[30,32]],
		"/(marketing)/blog/[slug]": [~238,[30,32]],
		"/(marketing)/(redirects)/brand": [224,[31]],
		"/(microsites)/c-function": [267],
		"/(marketing)/(redirects)/careers": [225,[31]],
		"/(marketing)/changelog": [~239,[30]],
		"/(marketing)/changelog/[slug]": [~240,[30]],
		"/(dash)/clusters/[workspace]/[environment]": [57,[5],[6]],
		"/(marketing)/(redirects)/(utm)/cometeer": [219,[31]],
		"/(marketing)/company": [~241,[30]],
		"/(dash)/containers/[workspace]/[environment]": [58,[5],[6]],
		"/(dash)/containers/[workspace]/[environment]/[tab=containersTab]": [59,[5],[6]],
		"/(marketing)/(redirects)/credits": [226,[31]],
		"/(marketing)/customers": [~242,[30]],
		"/(marketing)/(redirects)/(utm)/dancleary": [220,[31]],
		"/(dash)/(redirects)/dashboard": [50,[7]],
		"/(docs)/docs": [202,[20],[21]],
		"/(docs)/docs/cli/latest/[...id]": [~204,[20,22,23],[21]],
		"/(docs)/docs/devin": [205,[20],[21]],
		"/(docs)/docs/examples": [206,[20,24],[21]],
		"/(docs)/docs/examples/[...id]": [207,[20,24],[21]],
		"/(docs)/docs/guide/[...id]": [208,[20,25],[21]],
		"/(docs)/docs/sdk/go/latest/[...id]": [~209,[20,26,27],[21]],
		"/(docs)/docs/sdk/go/releases": [~210,[20,26],[21]],
		"/(docs)/docs/sdk/js/latest/[...id]": [~211,[20,26,28],[21]],
		"/(docs)/docs/sdk/js/releases": [~212,[20,26],[21]],
		"/(docs)/docs/sdk/py/latest/[...id]": [~213,[20,26,29],[21]],
		"/(docs)/docs/sdk/py/releases": [~214,[20,26],[21]],
		"/(docs)/docs/[...fallback]": [203,[20],[21]],
		"/(dash)/endpoints/[workspace]/[environment]": [60,[5],[6]],
		"/(dash)/endpoints/[workspace]/[environment]/create": [62,[5],[6]],
		"/(dash)/endpoints/[workspace]/[environment]/[endpointId]": [61,[5],[6]],
		"/(dash)/evaluations/[workspace]/[environment]": [63,[5,8],[6]],
		"/(dash)/evaluations/[workspace]/[environment]/create": [65,[5,8],[6]],
		"/(dash)/evaluations/[workspace]/[environment]/[jobId]": [64,[5,8],[6]],
		"/(marketing)/(redirects)/events": [227,[31]],
		"/(docs)/examples": [215],
		"/(microsites)/glm-5-endpoint": [~268],
		"/(marketing)/(redirects)/glossary": [228,[31]],
		"/(marketing)/(redirects)/(utm)/gopher": [221,[31]],
		"/(microsites)/gpu-glossary": [269,[34],[35]],
		"/(microsites)/gpu-glossary/[...id]": [270,[34],[35]],
		"/(dash)/(redirects)/home": [51,[7]],
		"/(dash)/id/[id]": [66,[5],[6]],
		"/(dash)/images/[workspace]/[environment]": [67,[5],[6]],
		"/(dash)/internal": [68,[9]],
		"/(dash)/internal/access-requests": [69,[9]],
		"/(dash)/internal/access-requests/audit": [70,[9]],
		"/(dash)/internal/accounts": [71,[9]],
		"/(dash)/internal/accounts/[...rest]": [72,[9]],
		"/(dash)/internal/batch": [73,[9]],
		"/(dash)/internal/billing-groups": [74,[9]],
		"/(dash)/internal/billing-groups/[groupId]": [75,[9]],
		"/(dash)/internal/bizops-audit-logs": [76,[9]],
		"/(dash)/internal/capacity-probes": [77,[9]],
		"/(dash)/internal/clusters": [78,[9]],
		"/(dash)/internal/commitments": [79,[9]],
		"/(dash)/internal/credit-codes": [80,[9]],
		"/(dash)/internal/credit-codes/[code]": [81,[9]],
		"/(dash)/internal/cube-memorial": [82,[9]],
		"/(dash)/internal/customer-onboarding": [83,[9]],
		"/(dash)/internal/design": [84,[9,10]],
		"/(dash)/internal/design/colors": [85,[9,10]],
		"/(dash)/internal/design/colors/dataviz": [86,[9,10]],
		"/(dash)/internal/design/components": [87,[9,10]],
		"/(dash)/internal/design/components/button": [88,[9,10]],
		"/(dash)/internal/design/components/checkbox": [89,[9,10]],
		"/(dash)/internal/design/components/dropdown": [90,[9,10]],
		"/(dash)/internal/design/graphics": [91,[9,10]],
		"/(dash)/internal/design/typography": [92,[9,10]],
		"/(dash)/internal/flash": [93,[9]],
		"/(dash)/internal/flash/[hostname]": [94,[9]],
		"/(dash)/internal/fleet-bench": [95,[9]],
		"/(dash)/internal/fraud": [96,[9]],
		"/(dash)/internal/gpu-capacity-management": [97,[9]],
		"/(dash)/internal/gpu-health": [98,[9]],
		"/(dash)/internal/gpu-shortfall": [99,[9]],
		"/(dash)/internal/gpus": [100,[9]],
		"/(dash)/internal/incident-management": [101,[9]],
		"/(dash)/internal/leased-notifiers": [102,[9]],
		"/(dash)/internal/logs": [103,[9]],
		"/(dash)/internal/lookup": [104,[9,11]],
		"/(dash)/internal/lookup/[id]": [105,[9,11]],
		"/(dash)/internal/machine-manager": [106,[9]],
		"/(dash)/internal/margins": [107,[9]],
		"/(dash)/internal/oauth-clients": [108,[9]],
		"/(dash)/internal/plans": [109,[9]],
		"/(dash)/internal/plans/change-workspace-plan": [111,[9]],
		"/(dash)/internal/plans/new": [112,[9]],
		"/(dash)/internal/plans/[plan_id]": [110,[9]],
		"/(dash)/internal/queues": [113,[9]],
		"/(dash)/internal/reservations": [114,[9]],
		"/(dash)/internal/resources": [115,[9]],
		"/(dash)/internal/resources/fullscreen": [116],
		"/(dash)/internal/sandbox-capacity-supply": [117,[9]],
		"/(dash)/internal/solver": [118,[9]],
		"/(dash)/internal/training-capacity": [119,[9]],
		"/(dash)/internal/users": [120,[9,12]],
		"/(dash)/internal/users/[userId]": [121,[9,12,13]],
		"/(dash)/internal/users/[userId]/administration": [122,[9,12,13]],
		"/(dash)/internal/users/[userId]/identity-providers": [123,[9,12,13]],
		"/(dash)/internal/users/[userId]/memberships": [124,[9,12,13]],
		"/(dash)/internal/vuln-portal": [125,[9]],
		"/(dash)/internal/worker-timeline": [126,[9]],
		"/(dash)/internal/workers": [127,[9]],
		"/(dash)/internal/workspaces": [128,[9,14]],
		"/(dash)/internal/workspaces/[workspace]": [129,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/access": [130,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/billing": [131,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/commitments": [132,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/credits": [133,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/egress": [134,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/environments": [135,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/invites": [136,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/invoices": [137,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/limits-and-overrides": [138,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/limits-and-overrides/legacy": [139,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/limits-and-overrides/preview": [140,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/members": [141,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/plan-history": [143,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/plan": [142,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/reservations": [144,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/resources": [145,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/stripe-controls": [146,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/usage": [147,[9,14,15]],
		"/(dash)/internal/workspaces/[workspace]/workers": [148,[9,14,15]],
		"/(marketing)/(redirects)/jobs": [229,[31]],
		"/(marketing)/legal/dpa": [243,[30]],
		"/(marketing)/legal/event": [244,[30]],
		"/(marketing)/legal/privacy-policy": [245,[30]],
		"/(marketing)/legal/terms-effective-date-march-2024": [247,[30]],
		"/(marketing)/legal/terms-effective-date-october-2025": [248,[30]],
		"/(marketing)/legal/terms": [246,[30]],
		"/(marketing)/library": [~249,[30]],
		"/(marketing)/library/[providerSlug]/[modelSlug]": [~250,[30]],
		"/(microsites)/llm-almanac": [271,[36]],
		"/(microsites)/llm-almanac/advisor": [272,[36]],
		"/(microsites)/llm-almanac/block-quants/[[format]]": [273,[36]],
		"/(microsites)/llm-almanac/how-to-benchmark": [274,[36]],
		"/(microsites)/llm-almanac/quant-formats/[[encoded]]": [275,[36]],
		"/(microsites)/llm-almanac/spec-dec-roofline": [276,[36]],
		"/(microsites)/llm-almanac/summary": [277,[36]],
		"/(microsites)/llm-almanac/token-timing-simulator": [278,[36]],
		"/(microsites)/llm-almanac/workloads": [279,[36]],
		"/(auth)/(signin)/login": [40,[2]],
		"/(auth)/(signin)/login/sso": [41,[2]],
		"/(dash)/logs/[workspace]/[environment]": [149,[5],[6]],
		"/(dash)/logs/[workspace]/[environment]/[appId]": [150,[5],[6]],
		"/(marketing)/(redirects)/lp/academics": [230,[31]],
		"/(marketing)/(redirects)/lp/startups": [231,[31]],
		"/notebooks": [289],
		"/notebooks/[workspace]/_/[id]": [292],
		"/notebooks/[workspace]/[id=likelyNotebookId]": [291],
		"/(dash)/notebooks/[workspace]/[environment]": [151,[5],[6]],
		"/notebooks/[workspace]/[environment]/[notebookId]": [290],
		"/(auth)/oauth/consent/[oauthRequestId]": [43,[3]],
		"/(marketing)/partners": [251,[30]],
		"/(auth)/phone-verification": [~44],
		"/(marketing)/(redirects)/playground/[...rest]": [232,[31]],
		"/(marketing)/(redirects)/(utm)/pragmatic": [222,[31]],
		"/(marketing)/pricing": [252,[30]],
		"/(marketing)/products/batch": [253,[30]],
		"/(marketing)/products/inference": [~254,[30]],
		"/(marketing)/(redirects)/products/notebooks": [233,[31]],
		"/(marketing)/products/platform": [~255,[30]],
		"/(marketing)/products/sandboxes": [~256,[30]],
		"/(marketing)/products/training": [~257,[30]],
		"/(dash)/runners/[workspace]/[environment]": [152,[5],[6]],
		"/(microsites)/runtime": [280],
		"/(microsites)/runtime/archive": [281],
		"/(microsites)/runtime/archive/agenda": [282],
		"/(microsites)/runtime/archive/map": [283],
		"/(microsites)/runtime/lab": [284],
		"/(microsites)/runtime/lab/badge": [285],
		"/(microsites)/runtime/lab/badge/card": [286],
		"/(microsites)/runtime/partner": [287],
		"/(microsites)/runtime/speakers": [288],
		"/(dash)/sandboxes/[workspace]/[environment]": [153,[5],[6]],
		"/(dash)/secrets/[workspace]/[environment]": [154,[5],[6]],
		"/(dash)/secrets/[workspace]/[environment]/create": [156,[5],[6]],
		"/(dash)/secrets/[workspace]/[environment]/[name]": [155,[5],[6]],
		"/(dash)/settings": [157,[16],[17]],
		"/(dash)/settings/[[workspace]]/access-controls": [163,[16,18,19],[17]],
		"/(dash)/settings/[[workspace]]/access-controls/environments": [164,[16,18,19],[17]],
		"/(dash)/settings/[[workspace]]/access-grants": [165,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/audit-logs": [166,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/billing": [167,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/custom-domains": [168,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/(redirects)/domains": [158,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/environments": [169,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/image-builder-version": [170,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/(redirects)/image-config": [159,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/limits": [171,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/metrics": [172,[16,18],[17]],
		"/(dash)/settings/notifications": [191,[16],[17]],
		"/(dash)/settings/[[workspace]]/page-an-engineer": [173,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/plans": [174,[16,18],[17]],
		"/(dash)/settings/profile": [192,[16],[17]],
		"/(dash)/settings/[[workspace]]/proxies": [175,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/proxy-auth-tokens": [176,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/(redirects)/proxy": [160,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/(redirects)/slack-integration": [161,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/slack-notifications": [177,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/tokens": [178,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/tokens/api-tokens": [179,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/tokens/member-tokens": [180,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/tokens/service-users": [181,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/usage": [182,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/webhooks": [183,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management": [184,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management/environments": [185,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management/environments/all": [186,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management/environments/workspace-defaults": [187,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management/groups": [188,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management/identity-and-provisioning": [189,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/(redirects)/workspace-management/limits": [162,[16,18],[17]],
		"/(dash)/settings/[[workspace]]/workspace-management/members": [190,[16,18],[17]],
		"/(dash)/settings/workspaces": [193,[16],[17]],
		"/(auth)/(signin)/signup": [42,[2]],
		"/(dash)/slack-link-workspace/[[workspace]]": [194,[5],[6]],
		"/(marketing)/(redirects)/slack": [234,[31]],
		"/(marketing)/solutions/audio": [258,[30]],
		"/(marketing)/solutions/coding-agents": [259,[30]],
		"/(marketing)/solutions/comp-bio": [260,[30]],
		"/(marketing)/solutions/image-and-video": [261,[30]],
		"/(marketing)/solutions/llm": [262,[30]],
		"/(marketing)/startups": [263,[30]],
		"/(dash)/storage/[workspace]/[environment]": [195,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/dicts": [197,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/nfs": [198,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/queues": [199,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/volumes": [200,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/volumes/[name]/[...dirName]": [201,[5],[6]],
		"/(dash)/storage/[workspace]/[environment]/[name]/[...dirName]": [196,[5],[6]],
		"/(marketing)/(redirects)/(utm)/t3gg": [223,[31]],
		"/(auth)/token-flow/[tokenFlowId]": [45,[4]],
		"/(marketing)/use-cases": [264,[30]],
		"/(marketing)/use-cases/[usecase]": [265,[30]],
		"/(marketing)/v2/components-test": [266,[33]],
		"/(dash)/(redirects)/[workspace=workspace]/[environment]/apps/[...rest]": [46,[7]],
		"/(dash)/(redirects)/[workspace=workspace]/[environment]/logs/[...rest]": [47,[7]],
		"/(dash)/(redirects)/[workspace=workspace]/[environment]/secrets/[...rest]": [48,[7]],
		"/(dash)/(redirects)/[workspace=workspace]/[environment]/storage/[...rest]": [49,[7]],
		"/(dash)/[fallback=dash]/[...rest]": [52,[5],[6]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);